import React from 'react';

const MainContent = (props) => (
    <div id="right" className="column content">
        {props.children}
    </div>
);

export default MainContent